// Ampel laut Vorgabe: grün > 0,8 · gelb 0,5–0,8 · rot < 0,5. 1,0 = vom Menschen geprüft.

export type Ampel = "gruen" | "gelb" | "rot" | "keine";

export const GEPRUEFT = 1.0;

export function ampel(konfidenz: number | undefined | null, hatWert = true): Ampel {
  if (konfidenz === undefined || konfidenz === null) return hatWert ? "keine" : "rot";
  if (konfidenz > 0.8) return "gruen";
  if (konfidenz >= 0.5) return "gelb";
  return "rot";
}

export const AMPEL_TEXT: Record<Ampel, string> = {
  gruen: "Sicher erkannt",
  gelb: "Bitte prüfen",
  rot: "Unsicher / fehlt",
  keine: "Manuell",
};

export const AMPEL_KLASSEN: Record<Ampel, { punkt: string; rahmen: string; hintergrund: string; text: string }> = {
  gruen: { punkt: "bg-ampel-gruen", rahmen: "border-ampel-gruen/60", hintergrund: "bg-ampel-gruenHell", text: "text-ampel-gruen" },
  gelb: { punkt: "bg-ampel-gelb", rahmen: "border-ampel-gelb", hintergrund: "bg-ampel-gelbHell", text: "text-ampel-gelb" },
  rot: { punkt: "bg-ampel-rot", rahmen: "border-ampel-rot", hintergrund: "bg-ampel-rotHell", text: "text-ampel-rot" },
  keine: { punkt: "bg-neutral-300", rahmen: "border-neutral-300", hintergrund: "bg-neutral-100", text: "text-neutral-500" },
};

export function prozent(konfidenz: number | undefined | null): string {
  if (konfidenz === undefined || konfidenz === null) return "–";
  return `${Math.round(konfidenz * 100)} %`;
}
